import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import { InvoiceSheetContainer, InvoiceSheetWrap } from './index.styled'
import InvoiceSheet from '../InvoiceSheet'
import { getInvoiceSheetLanguage } from '../InvoiceSheet/helper'
import { isPostPaymentInvoice } from '../../constants'

const INVOICE_SHEET_LANGUAGE = 'de'
const SHEET_LANGUAGE_OPTIONS = { de: { lng: 'de' }, es: { lng: 'es' } }
const PRINT_THEME = { colorTheme: 'LIGHT' }

const InvoiceSheetForPrint = React.memo(() => {
	const invoice = useSelector(store => store.invoice.selectedInvoice)
	const language = isPostPaymentInvoice(invoice) ? getInvoiceSheetLanguage(invoice.company) : INVOICE_SHEET_LANGUAGE
	const { t } = useTranslation(undefined, { lng: language, useSuspense: false })

	return (
		<ThemeProvider theme={PRINT_THEME}>
			<InvoiceSheetContainer>
				<InvoiceSheetWrap id="invoice-sheet-for-print">
					{invoice && <InvoiceSheet invoice={invoice} t={t} lng={SHEET_LANGUAGE_OPTIONS[language]} layout="print" />}
				</InvoiceSheetWrap>
			</InvoiceSheetContainer>
		</ThemeProvider>
	)
})

InvoiceSheetForPrint.displayName = 'InvoiceSheetForPrint'
export default InvoiceSheetForPrint
